import React from 'react'
import { useSelector } from 'react-redux'
import { DialogBox } from 'components/Zui'
import { useIntl } from 'hooks'
import { validationSchema } from 'schema/collection'
import { collectionsNames } from 'features/collections-list/collectionSlice'
import { FormContainer, Input } from 'components/Form'
import Modal from 'components/Modals'

const Create = ({ onSubmit, onClose }) => {
    const { t } = useIntl()
    const existingCollections = useSelector(collectionsNames)

    return (
        <Modal>
            <FormContainer
                initialValues={{
                    name: '',
                    existingCollections,
                }}
                onSubmit={values => {
                    onSubmit(values)
                }}
                validationSchema={validationSchema(t)}
                validateOnBlur={false}
            >
                {formik => {
                    return (
                        <DialogBox
                            closable
                            headerText={t('create.collection')}
                            acceptLabel={t('create')}
                            cancelLabel={t('cancel')}
                            onClose={onClose}
                            onCancel={onClose}
                            onAccept={formik.handleSubmit}
                            confirmPosition="right"
                        >
                            <div className="dialog-content-wrap">
                                <Input
                                    noLabel
                                    name="name"
                                    type="textfield"
                                    placeholder={t('collection.name')}
                                />
                            </div>
                        </DialogBox>
                    )
                }}
            </FormContainer>
        </Modal>
    )
}

export default Create
